export default __webpack_public_path__ + "static/media/greenCheck.c11c64bb.svg";